import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import { makeStyles } from '@material-ui/core/styles'
import { ThemeProvider } from '@material-ui/core'
import { unstable_createMuiStrictModeTheme } from '@material-ui/core/styles'

import './styles.css';

import Icon from '../../assets/icon.svg';
import Logo from '../../assets/logo.svg';

import Programmation from '../../components/Programmation';
import Submit from '../../components/Submit';
import Contest from "../../components/Contest";
import About from '../../components/About';

import DrawerMenu from '../../components/DrawerMenu';

const useStyles = makeStyles({
    menuItem: {
        color: '#D25600',
        fontSize: '1.1em',
        fontWeight: 500
    },
})

const theme = unstable_createMuiStrictModeTheme()

export default function Home() {
    const [anchorEl, setAnchorEl] = useState(null)

    const classes = useStyles()

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    return (
        <div id="main">
            <div id="home-container">
                <div id="topBar">
                    <div id="icon-container">
                        <img src={Icon} alt="Icon - SMA" />
                    </div>
                    <ul id="option-container">
                        <li className="option">
                            <a href='#programmation-container'>Programação</a>
                        </li>
                        <li className="option">
                            <ThemeProvider theme={theme}>
                                <div aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick}>Concursos</div>
                                <Menu
                                    id="simple-menu"
                                    anchorEl={anchorEl}
                                    keepMounted
                                    open={Boolean(anchorEl)}
                                    onClose={handleClose}
                                >
                                    <MenuItem className={classes.menuItem} onClick={handleClose} component='a' href='#submit-container'>Submissão</MenuItem>
                                    <MenuItem className={classes.menuItem} onClick={handleClose} component='a' href='#contest-section'>Trabalhos Aprovados</MenuItem>
                                </Menu>
                            </ThemeProvider>
                        </li>
                        <li className="option">
                            <a href='#about-section'>Sobre o evento</a>
                        </li>
                        <li className="option">
                            <Link to={'/duvidas'}>Dúvidas</Link>
                        </li>
                    </ul>
                    <DrawerMenu />
                </div>

                <div id="subscribe-container">
                    <div id="information-container">
                        <div id="text-container">
                            <h2>SEMANA DO MEIO AMBIENTE 2020</h2>
                            <h4>IFPB <i>Campus</i> Cajazeiras</h4>
                            <p>
                                As Comissões de Gerenciamento dos Resíduos Sólidos e de Políticas Ambientais do IFPB/ Campus Cajazeiras estão promovendo o evento on-line “Socied@de e Naturez@: diálogos virtuais em tempos de pandemia”, que contará com uma vasta programação, incluindo lives, webinars, oficinas virtuais, concurso ambiental e Eco Cine debate, nos dias 03, 04 e 05 de junho de 2020.
                            </p>
                            <p><a href="https://drive.google.com/file/d/1S35tI7qyde6K4kSOC3MBBlU4O8VqGqr4/view?usp=sharing">Resultado do I Concurso Ambiental da Semana do Meio Ambiente 2020 - IFPB, Campus Cajazeiras</a></p>
                        </div>
                        <button onClick={() => window.location.href = 'https://forms.gle/7MmTfushGUhduED5A'}>INSCREVA-SE</button>
                    </div>
                    <div id="logo-container">
                        <img src={Logo} alt="Logo - SMA" />
                    </div>
                </div>
            </div>

            <Programmation />
            <Submit />
            <Contest />
            <About />
        </div>
    )
}
